<template>
  <div class="containerPostagens">
    <b-modal centered size="md" id="modalVisualization" hide-header hide-footer>
      <b-col align="start">
        <a v-b-modal @click="hideModal('modalVisualization')">
          <b-icon-arrow-left></b-icon-arrow-left>
        </a>
      </b-col>
      <p id="textoAssuntoModal"><strong>Comentário: </strong>{{ this.dados.answer }}</p>
      <p id="mostrarTudoModal"><strong>Comentário: </strong>{{ this.dados.answer }}</p>
      <b-col class="mb-2 mt-3">
        <div class="emojis">
          <div class="flex1">
            <b-img
              class="icons"
              :src="require('@/assets/dashboard/heart.svg')"
              alt="Icone heart"
            />
            {{ this.dados.reactions.amei }}
          </div>
          <div class="flex1">
            <b-img
              class="icons"
              :src="require('@/assets/dashboard/punho-fechado.svg')"
              alt="Icone punho fechado"
            />
            {{ this.dados.reactions.empoderada }}
          </div>
          <div class="flex1">
            <b-img
              class="icons"
              :src="require('@/assets/dashboard/aperto-de-mao.svg')"
              alt="Icone aperto de mao"
            />
            {{ this.dados.reactions.triste }}
          </div>
        </div>
      </b-col>
      <b-col class="nomes">
        <p><strong>Nome: </strong>{{ this.dados.question }}</p>
      </b-col>
      <b-row align-h="between">
        <b-col cols="4">
          <b-button id="buttonLeiaMaisModal" @click="leiaMais1">Leia mais</b-button>
          <b-button id="buttonLeiaMenosModal" @click="leiaMenos1">Leia menos</b-button>
        </b-col>
        <b-col cols="3">
          <b-button id="button1" class="buttons1" v-b-modal.idModalExcluirComment
            >Excluir</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <PopupConfirmacao
      cor_imagem="#E2574C"
      titulo="Atenção"
      texto="O comentário será excluído permantemente. Deseja continuar?"
      texto_botao1="Continuar"
      cor_botao1="#FFFFFF"
      cor_background_botao1="#EB5353"
      hover_botao1="#a53a36"
      texto_botao2="Cancelar"
      cor_botao2="#FFFFFF"
      cor_background_botao2="#ADADAD"
      hover_botao2="#8b8b8b"
      :confirma_acao="deletar"
      id_modal="idModalExcluirComment"
    />
    <ModalAlert
      idModal="SuccessDelete"
      msg="O Comentário foi excluido com sucesso!"
      colorFont="green"
    />

    <b-row>
      <b-col cols="11" lg="10">
        <div
          type="text"
          name="text"
          required
          class="mensagemPost"
          autocomplete="off"
          placeholder=""
          rows="7"
          no-resize
        >
          <p id="textoAssunto"><strong>Assunto: </strong>{{ this.MESSAGE }}</p>
          <p id="mostrarTudo"><strong>Assunto: </strong>{{ this.MESSAGE }}</p>
          <b-button id="buttonLeiaMais" @click="leiaMais">Leia mais</b-button>
          <b-button id="buttonLeiaMenos" @click="leiaMenos">Leia menos</b-button>
        </div>
      </b-col>
      <b-col cols="11" lg="10">
        <div
          type="text"
          name="text"
          required
          class="namePost"
          autocomplete="off"
          placeholder=""
          rows="7"
          no-resize
        >
          <b-row>
            <b-col>
              <p><strong>Remetente: </strong>{{ this.MAILER }}</p>
            </b-col>
            <b-col>
              <div class="emojis">
                <div class="flex">
                  <b-img
                    class="icons"
                    :src="require('@/assets/dashboard/heart.svg')"
                    alt="Icone heart"
                  />
                  {{ this.reactions.amei }}
                </div>
                <div class="flex">
                  <b-img
                    class="icons"
                    :src="require('@/assets/dashboard/punho-fechado.svg')"
                    alt="Icone punho fechado"
                  />
                  {{ this.reactions.empoderada }}
                </div>
                <div class="flex">
                  <b-img
                    class="icons"
                    :src="require('@/assets/dashboard/aperto-de-mao.svg')"
                    alt="Icone aperto de mao"
                  />
                  {{ this.reactions.triste }}
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="10">
        <b-table
          hover
          bordered
          responsive
          class="mt-3 mb-5 table"
          id="my-table"
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template v-slot:cell(buttons)="data">
            <div class="buttonParaVerComentario">
              <a
                style="margin-right: 0.5rem; margin-top: 3rem"
                v-b-modal.modalVisualization
                @click="abrirModal(data.item)"
              >
                <b-icon-eye-fill class="icons" scale="1"></b-icon-eye-fill>
              </a>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row class="rowPagination" align-h="start">
      <b-col cols="7" sm="5" md="4" lg="5">
        <b-pagination
          class="pagination"
          :total-rows="rows"
          :per-page="perPage"
          v-model="currentPage"
          style="margin-top: -30px; margin-bottom: 22px"
        >
        </b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { GetAnonymousPostsId } from '@/services/api/AnonymousContact.js';
import { GetComments, GetCommentsAll, deleteComment } from '@/services/api/comments.js';
import PopupConfirmacao from '@/components/dashboard/PopupConfirmacao.vue';
import ModalAlert from '@/components/dashboard/ModalAlert.vue';
export default {
  components: {
    PopupConfirmacao,
    ModalAlert,
  },
  data() {
    return {
      destinationId: this.$route.params.id,
      MESSAGE: '',
      MAILER: '',
      perPage: 0,
      rows: 0,
      currentPage: 1,
      fields: [
        {
          key: 'question',
          label: 'Nomes',
          tdClass: 'question',
          thClass: 'th-question',
        },
        {
          key: 'answer',
          label: 'Comentários',
          tdClass: 'answer',
          thClass: 'th-answer',
        },
        {
          key: 'buttons',
          label: '',
          tdClass: 'buttons',
          thClass: 'th-buttons',
        },
      ],
      items: [],
      dados: {
        id: '',
        answer: '',
        question: '',
        reactions: {
          amei: 0,
          empoderada: 0,
          triste: 0,
        },
      },
      reactions: {
        amei: 0,
        empoderada: 0,
        triste: 0,
      },
    };
  },
  methods: {
    abrirModal(item) {
      this.dados = item;
    },
    deletar() {
      deleteComment(this.dados.id)
        .then(() => {
          this.hideModal('modalVisualization');
          this.hideModal('idModalExcluirComment');
          this.showModal('SuccessDelete');
          setTimeout(() => {
            this.hideModal('SuccessDelete');
            this.$router.go(0);
          }, 2000);
        })
        .catch(() => {
          this.$bvToast.toast(
            'Erro deletar comentario, recarregue a página e tente novamente. Caso persista, tente novamente mais tarde.',
            {
              title: 'Erro ao deletar comentario',
              autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
              variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
            },
          );
        });
    },
    hideModal(id) {
      this.$root.$emit('bv::hide::modal', id, '#btnShow');
    },
    showModal(id) {
      this.$root.$emit('bv::show::modal', id, '#btnShow');
    },
    leiaMais() {
      document.getElementById('textoAssunto').style.display = 'none';
      document.getElementById('mostrarTudo').style.display = 'inline';
      document.getElementById('buttonLeiaMais').style.display = 'none';
      document.getElementById('buttonLeiaMenos').style.display = 'block';
    },
    leiaMenos() {
      document.getElementById('textoAssunto').style.display = '-webkit-box';
      document.getElementById('mostrarTudo').style.display = 'none';
      document.getElementById('buttonLeiaMais').style.display = 'inline';
      document.getElementById('buttonLeiaMenos').style.display = 'none';
    },
    leiaMais1() {
      document.getElementById('textoAssuntoModal').style.display = 'none';
      document.getElementById('mostrarTudoModal').style.display = 'inline';
      document.getElementById('buttonLeiaMaisModal').style.display = 'none';
      document.getElementById('buttonLeiaMenosModal').style.display = 'block';
    },
    leiaMenos1() {
      document.getElementById('textoAssuntoModal').style.display = '-webkit-box';
      document.getElementById('mostrarTudoModal').style.display = 'none';
      document.getElementById('buttonLeiaMaisModal').style.display = 'inline';
      document.getElementById('buttonLeiaMenosModal').style.display = 'none';
    },
  },
  mounted() {
    GetComments(this.destinationId)
      .then((res) => {
        this.items = res.data.map((item) => {
          return {
            question: item.name,
            answer: item.message,
            id: item._id,
            aproved: item.aproved,
            reactions: {
              amei: item.reactions.amei,
              empoderada: item.reactions.empoderada,
              triste: item.reactions.triste,
            },
          };
        });
        this.rows = this.items.length;
        GetCommentsAll()
          .then((resposta) => {
            this.perPage = resposta.data.commentsPerPage;
            this.currentPage = resposta.data.currentPage;
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status != 404) {
                this.$bvToast.toast(
                  'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
                  {
                    title: 'Erro interno no servidor',
                    autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                    variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                  },
                );
              }
            }
          });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status != 404) {
            this.$bvToast.toast(
              'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
              {
                title: 'Erro interno no servidor',
                autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
              },
            );
          }
        }
      });
    GetAnonymousPostsId(this.destinationId)
      .then((res) => {
        this.MESSAGE = res.data.message;
        this.MAILER = res.data.mailer;
        this.reactions.amei = res.data.reactions.amei;
        this.reactions.empoderada = res.data.reactions.empoderada;
        this.reactions.triste = res.data.reactions.triste;
      })
      .catch((err) => {
        console.error(err);
        this.$bvToast.toast(
          'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
          {
            title: 'Erro interno no servidor',
            autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
            variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
          },
        );
      });
  },
};
</script>

<style lang="scss" scoped>
.emojis {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.titleModalConfirmar {
  font-family: 'Noto Sans', sans-serif;
  color: #000000;
}
.textModalConfirmar {
  font-family: 'Noto Sans', sans-serif;
  color: #000000;
}

.flex1 {
  // display: flex;
  margin-right: 1rem;
}
.flex {
  // display: flex;
  margin-right: 0.5rem;
}
.icons {
  height: 1.5rem;
}
#textoAssunto {
  overflow: hidden; // Removendo barra de rolagem
  text-overflow: ellipsis; // Adicionando "..." ao final
  display: -webkit-box;
  -webkit-line-clamp: 2; // Quantidade de linhas
  -webkit-box-orient: vertical;
}
#textoAssuntoModal {
  overflow: hidden; // Removendo barra de rolagem
  text-overflow: ellipsis; // Adicionando "..." ao final
  display: -webkit-box;
  -webkit-line-clamp: 2; // Quantidade de linhas
  -webkit-box-orient: vertical;
}

#buttonLeiaMais {
  background-color: #343842;
  display: inline;
}
#buttonLeiaMenos {
  display: none;
  margin-top: 1rem;
  background-color: #343842;
}
#buttonLeiaMaisModal {
  background-color: #343842;
  display: inline;
}
#buttonLeiaMenosModal {
  display: none;
  margin-top: 0rem;
  background-color: #343842;
}
#button1.buttons1.btn-secondary {
  background-color: #eb5353;
}
#mostrarTudo {
  display: none;
}
#mostrarTudoModal {
  display: none;
}
.mensagemPost {
  padding: 1rem;
  border: 1px solid black;
  border-radius: 0.3rem;
  background-color: rgb(255, 255, 255);
}
.namePost {
  padding: 1rem;
  background-color: transparent;
}
@media (min-width: 769px) and (max-width: 1024px) {
  .main {
    margin-left: 11rem;
  }
  #buttonLeiaMenosModal {
    margin-top: 0;
  }
  #buttonLeiaMaisModal {
    width: 97px;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .main {
    margin-left: 8.5rem;
    margin-right: 0.5rem;
  }
  .buttonPosition {
    margin-right: 0rem;
    margin-bottom: 1rem;
  }
  #buttonLeiaMenosModal {
    margin-top: 0;
  }
  #buttonLeiaMaisModal {
    width: 97px;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .main {
    margin-left: 6.3rem;
  }
  .emojis {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-right: 4rem;
    margin-top: 0.5rem;
  }
  .flex {
    margin-right: 1rem;
  }
  #buttonLeiaMenosModal {
    width: 112px;
    margin-top: 0;
  }
  #buttonLeiaMaisModal {
    width: 97px;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .main {
    margin-left: 5.4rem;
  }
  .emojis {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-right: 3rem;
    margin-top: 0.5rem;
  }
  .flex {
    margin-right: 1rem;
  }
  #buttonLeiaMenosModal {
    width: 112px;
    margin-top: 0;
  }
  #buttonLeiaMaisModal {
    width: 97px;
  }
  #button1.buttons1.btn-secondary {
    margin-left: -1rem;
  }
}
@media (max-width: 320px) {
  .main {
    margin-left: 5rem;
  }
  .emojis {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-right: 2rem;
    margin-top: 0.5rem;
  }
  .flex {
    margin-left: 0.1rem;
  }
  .icons {
    height: 1rem;
  }
  #button1.buttons1.btn-secondary {
    margin-left: -1rem;
  }
  #buttonLeiaMaisModal {
    width: 91px;
  }
  #buttonLeiaMenosModal {
    width: 112px;
    margin-top: 0;
  }
}
@media (max-width: 280px) {
  .emojis {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-right: 0.5rem;
    margin-top: 0.5rem;
  }
  .icons {
    height: 1rem;
  }
  .flex {
    margin-right: 0.8rem;
  }
}
</style>
<style lang="scss">
.containerPostagens {
  .btn-secondary {
    background-color: #343842;
  }
  .buttonParaVerComentario {
    margin-top: 0.7rem;
  }
  #invt-modal .modal-header,
  #invt-modal .modal-footer {
    display: none;
  }
  .question {
    text-align: left;
    font-weight: 300;
    border-right: 3px solid #343842 !important;
  }

  .th-question {
    width: 9rem;
    border-bottom: 3px solid #343842 !important;
    border-right: 3px solid #343842 !important;
    text-align: left;
  }

  .answer {
    text-align: left;
    font-weight: 300;
    max-width: 400px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .th-answer {
    border-bottom: 3px solid #343842 !important;
    text-align: left;
  }

  .th-buttons {
    width: 2rem;
    border-left-style: hidden !important;
    border-bottom: 3px solid #343842 !important;
  }

  .buttons {
    padding: unset !important;
    border-left-style: hidden !important;
  }

  .div-itens {
    width: 100%;
    height: 100%;
    display: flex;
    vertical-align: middle;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  .icons {
    color: #000;
  }
  .icons:hover {
    color: #343842 !important;
  }
  .pagination .page-link,
  .pagination .page-link:hover {
    color: #343842;
  }

  .pagination .page-item.active .page-link {
    background-color: #343842;
    color: #e5e5e5;
  }
  .pagination .page-item.active .page-link:hover {
    color: #e5e5e5;
  }

  .row-hidden {
    display: none;
  }
}
</style>
